import './style.scss'
import { Button, Drawer, Input, message, Modal, notification, Radio, Space, Spin } from 'antd'
import { FC, useEffect, useState } from 'react'
import * as homeApi from '@/api/home'
import error1 from '@/assets/error1.png'
import error2 from '@/assets/error2.png'
import error3 from '@/assets/error3.png'
import error4 from '@/assets/error4.png'
import { eventTracking } from '@/libs/util'
import { ExclamationCircleFilled } from '@ant-design/icons'
import Upload from '../UploadVideo'

interface IProps {
  open: boolean
  onCancel?: () => void
  onOk?: () => void
  group?: any
}

const CreateInteractAvatarDrawer: FC<IProps> = (props) => {
  const { open, group, onCancel, onOk } = props
  const [videoInfo, setVideoInfo] = useState<any>({})
  const [name, setName] = useState('')
  const [title, setTitle] = useState('')
  const [declareChecked, setDeclareChecked] = useState(false)
  const [guideModalOpen, setGuideModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const uploadList = [
    {
      key: 'open',
      value: '请上传一段开口视频'
    },
    {
      key: 'close',
      value: '请上传一段闭口视频'
    }
  ]

  useEffect(() => {
    setGuideModalOpen(!localStorage.getItem('guideRead'))
  }, [])

  useEffect(() => {
    if (open) {
      setName('')
      setDeclareChecked(false)
      showDeclare()
      setVideoInfo({
        closed_mouth_video_oss_key: undefined,
        open_mouth_video_oss_key: undefined
      })
    }
  }, [open])

  useEffect(() => {
    if (group?.id) {
      setTitle(`${group.name}-形象${(group.avatar_count || 0) + 1}`)
    }
  }, [group])

  const onGuideModalClose = () => {
    setGuideModalOpen(false)
    localStorage.setItem('guideRead', '1')
  }

  const onUploadSuccess = (key: string, video: any) => {
    if (key === 'open') {
      setVideoInfo((v: any) => {
        return {
          ...v,
          open_mouth_video_oss_key: video.oss_key
        }
      })
    }
    if (key === 'close') {
      setVideoInfo((v: any) => {
        return {
          ...v,
          closed_mouth_video_oss_key: video.oss_key
        }
      })
    }
  }

  const onRestartUpload = (key: string) => {
    if (key === 'open') {
      setVideoInfo({
        ...videoInfo,
        open_mouth_video_oss_key: undefined
      })
    }
    if (key === 'close') {
      setVideoInfo({
        ...videoInfo,
        closed_mouth_video_oss_key: undefined
      })
    }
  }

  const showDeclare = () => {
    let index = 3

    const instance = Modal.confirm({
      width: 600,
      title: '使用者承诺须知',
      content: (
        <>
          <div>
            本声明将帮助您更好的在【飞影数字人】平台（下称“本平台”）使用相关工具上传和管理您的作品。您若上传作品，即视为您已充分知悉并充分接受以下内容：
          </div>
          <ul className="declare-list">
            <li>您作为使用者在本平台上传、发布的作品，应具有独立、完整的知识产权，不得侵犯他人知识产权等任何权利。</li>
            <li>
              您在使用本平台及上传、发布作品时，应当自觉遵守国家法律、法规，遵守公共秩序，尊重社会公德、社会主义制度、国家利益、公民合法权益、道德风尚和信息真实性等要求。如有违反，一经本平台发现将根据违规程度采取包括但不限于删除、下架、禁止发布内容、封禁账号等处理方式。如造成恶劣影响或涉嫌违法犯罪的，本平台将有权向有关管理机关或公安机关提交相关内容，并配合进行调查。
            </li>
            <li>
              若您上传的作品及作品中的素材（包括但不限于创意、文本、肖像、音频、图片、视频等）侵犯了任何第三方权利，本平台均有权在收到相关侵权投诉后对该被投诉的作品或用户账号依据相应规则，采取包括但不限于
              <label className="red">下架、警告、封禁账号</label>等处理方式。
            </li>
            <li>
              请勿使用我们的服务克隆或生成任何侵犯版权、违反道德伦理、或违反中华人民共和国法律法规的内容。我们生成的所有内容均带有详细日志，自动/人工复审，以及
              可溯源的隐形视频/音频水印，
              <label className="red">若发现您违反了相关规则，我们保留终止您的服务并上报公安机关等机构的权利。</label>
            </li>
            <li>
              更多信息请参阅
              <a target="_blank" href="/eula.html">
                用户协议
              </a>
              、
              <a target="_blank" href="/privacy_agreement.html">
                隐私协议
              </a>
              。
            </li>
          </ul>
        </>
      ),

      okText: (
        <div>
          我已知晓，同意<label style={{ display: 'inline-block', width: 36 }}>（{index}s）</label>
        </div>
      ),
      cancelText: '取消',
      okButtonProps: {
        disabled: true
      },
      onOk: () => {
        setDeclareChecked(true)
      },
      onCancel: () => {
        setDeclareChecked(false)
        onCancel?.()
      }
    })

    const si = setInterval(() => {
      index = index - 1
      instance.update({
        okText: (
          <div>
            我已知晓，同意{index > 0 ? <label style={{ display: 'inline-block', width: 36 }}>（{index}s）</label> : ''}
          </div>
        )
      })
      if (index < 1) {
        instance.update({
          okButtonProps: {
            disabled: false
          }
        })
        clearInterval(si)
      }
    }, 1000)
  }

  const completeCreate = async () => {
    if (!name?.trim() && !group?.id) {
      return message.warning('请输入数字人的名字')
    }

    if (!videoInfo?.open_mouth_video_oss_key) {
      return message.warning('请上传开口视频')
    }

    if (!videoInfo?.closed_mouth_video_oss_key) {
      return message.warning('请上传闭口视频')
    }

    eventTracking('InstantCloneConfirm')
    setLoading(true)
    try {
      if (group?.id) {
        await homeApi.addDigitalAvatar(group.id, {
          avatars: [
            {
              name: title,
              closed_mouth_video_oss_key: videoInfo.closed_mouth_video_oss_key,
              open_mouth_video_oss_key: videoInfo.open_mouth_video_oss_key
            }
          ]
        })
      } else {
        await homeApi.addDigital({
          name,
          init_avatars: [
            {
              name: `${name}-形象1`,
              closed_mouth_video_oss_key: videoInfo.closed_mouth_video_oss_key,
              open_mouth_video_oss_key: videoInfo.open_mouth_video_oss_key
            }
          ]
        })
      }

      notification.success({
        message: '提交成功'
      })
      onCancel?.()
      onOk?.()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Drawer
      className="create-drawer"
      open={open}
      title="创建实时互动数字人"
      width={720}
      onClose={onCancel}
      footer={
        <>
          <div className="declare">
            <Radio checked={declareChecked} onClick={() => setDeclareChecked(!declareChecked)}></Radio>
            我已阅读并同意
            <label className="link" onClick={showDeclare}>
              《使用者承诺须知》
            </label>
          </div>
          <Space>
            <Button onClick={onCancel}>取消</Button>
            <Button disabled={!declareChecked} type="primary" loading={loading} onClick={completeCreate}>
              {loading ? '生成中' : '提交'}
            </Button>
          </Space>
        </>
      }
    >
      <Spin spinning={loading} tip={'数字人复刻中'}>
        <div className="main">
          <div className="form-item">
            <div className="title">数字人名称</div>
            <Input
              maxLength={20}
              placeholder="请输入数字人名称"
              value={group?.name || name}
              onChange={(e) => setName(e.target.value)}
              disabled={group?.id}
            />
          </div>

          {group?.id && (
            <div className="form-item">
              <div className="title">形象名称</div>
              <Input
                maxLength={20}
                placeholder="请输入形象名称"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          )}

          <div className="form-item">
            <div className="title">
              上传视频
              <ExclamationCircleFilled
                onClick={() => {
                  eventTracking('InstantCloneTips')
                  setGuideModalOpen(true)
                }}
              />
            </div>

            <div className="warning">
              <h4>视频要求</h4>
              <div className="desc">
                <div>
                  <label className="label">视频方向：</label>
                  <label>横向或纵向</label>
                </div>
                <div>
                  <label className="label">文件格式：</label>
                  <label>mp4、mov</label>
                </div>
                <div>
                  <label className="label">视频时长：</label>
                  <label>10秒~5分钟</label>
                </div>
                <div>
                  <label className="label">分辨率：</label>
                  <label>720p~1080p</label>
                </div>
                <div>
                  <label className="label">文件大小：</label>
                  <label>小于500MB</label>
                </div>
              </div>
            </div>
            {open && (
              <div className="upload-wrapper">
                {uploadList.map((l) => (
                  <div className="content" key={l.key}>
                    <Upload
                      onUploadSuccess={onUploadSuccess.bind(this, l.key)}
                      onRestartUpload={onRestartUpload.bind(this, l.key)}
                      uploadText={l.value}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          <Modal
            title="视频要求"
            open={guideModalOpen}
            footer={
              <Button type="primary" onClick={onGuideModalClose}>
                知道了
              </Button>
            }
            closeIcon={false}
            width={580}
            onCancel={onGuideModalClose}
          >
            <div className="modal-guide">
              <ul>
                <li>
                  <label>1.</label>不要使用有多人的视频
                </li>
                <li>
                  <label>2.</label>确保人脸不要太小，建议人脸宽度占整体画面宽度的1/4以上
                </li>
                <li>
                  <label>3.</label>人脸不要太大，确保整张人脸都在屏幕区域内，人脸不要出屏幕
                </li>
                <li>
                  <label>4.</label>确保面部特征没有被遮挡，并努力让面部清晰可见
                </li>
                <li>
                  <label>5.</label>上传的视频分辨率不应低于360p，也不应超过3840p，建议分辨率为720p或1080p
                </li>
                <li>
                  <label>6.</label>视频长度不应少于5秒，不超过30分钟
                </li>
              </ul>
              <div className="guide-error">
                <div className="title-error">错误示例</div>
                <div className="error-list">
                  <div className="item">
                    <img className="img1" src={error1} />
                    <div>多张人脸</div>
                  </div>
                  <div className="item">
                    <img className="img2" src={error2} />
                    <div>人脸太大</div>
                  </div>
                  <div className="item">
                    <img className="img3" src={error3} />
                    <div>脸部遮挡</div>
                  </div>
                  <div className="item">
                    <img className="img3" src={error4} />
                    <div>检测不到人脸</div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </Spin>
    </Drawer>
  )
}

export default CreateInteractAvatarDrawer
